import { z } from "zod";
import { AgendaSchema } from "../../models/agenda.schema";

export const PrivateAgendaControllerResponseSchema = {
  listAgendas: AgendaSchema.array(),

  getAgenda: AgendaSchema.nullable(),

  createAgenda: AgendaSchema,

  updateAgenda: AgendaSchema,

  deleteAgenda: z.void(),
};
